const serverPath = {
  development: "https://invoice.gosite.run",
  //development: "http://localhost:4000",
  staging: "https://invoice.gosite.run",
  production: "https://invoices.gosite.com",
}

const dashboardServerPath = {
  development:  "https://webapi.gosite.run",
  //development:  "http://localhost:3500",
  main: "https://webapi.gosite.run",
  sprint: "https://webapi.gosite.run",
  staging:  "https://webapi.gosite.run",
  production: "https://webapi.gosite.com"
}

const paymentServerPath = {
  development: "https://webapi.pay.gosite.run",
  //development: "http://localhost:8098",
  main: "https://webapi.pay.gosite.run",
  sprint: "https://webapi.pay.gosite.run",
  staging: "https://webapi.pay.gosite.run",
  production: "https://webapi.pay.gosite.com"
}

console.log(process.env.REACT_APP_ENV || "development")
const appEnvironment = process.env.REACT_APP_ENV || "development";
const server = serverPath[appEnvironment];
const dashboardServer = dashboardServerPath[appEnvironment];
const paymentApi = paymentServerPath[appEnvironment];

const version = '/v1/api/'
const all = {
  routes: {
    businessOwner: "/users/business-owner-info",
    sentOtp:"/user/onboarding",
    verifyOtp: "/user/verify",
    verifyOtpAutoLogin: "/user/verify/autoLogin",
    me:"/user/me",
    listInvoices: "/invoices/user",
    paymentList:"/payments/user",
    payment: "/invoices/user/pay",
    paymentIntent: `${paymentApi}/v2/api/stripe/processing/payment`,
    getPlaidLinkToken: `${paymentApi}/v2/api/plaid/processing/getPlaidLinkToken`,
    stripeACHPayment: `${paymentApi}/v2/api/stripe/processing/achPayment`,
    createMandate: `${paymentApi}/v2/api/stripe/processing/createmandate`,
    postPayment: `${paymentApi}/v2/api/stripe/processing/postpay`,
    addTip:"/invoices/user/add-tip",
    userBusiness:"/business",
    paymentType:"/invoices/user/payment-type",
    getReceipt:"/invoices/receipt",
    createReview: "/reviewmanager/email/payment/create",
    cardconnectCards: "/cardconnect/card",
    getSMBStripeCustomerID: "/stripe/getSMBStripeCustomerID",
    getPlatformCustomerId: "/stripe/getPlatformCustomerId",
    getStripeCards:`${paymentApi}/v2/api/stripe/processing/getEndUserSavedCards`,
    deleteStripeCards:`${paymentApi}/v2/api/stripe/processing/removeEndUserSavedCards`,
    cardconnectDefault: "/cardconnect/set-default-card",
    getMerchantId:"/cardconnect/get-merchant-id",
    offline:"/activity",
    segment:"/segment/track",
    invoice:"/invoices/user",
    trackTransactionStatusChange: "/transactions/track-single-user-payment-status-change",
    failedTransaction: 'stripe/failed-transaction',
    bussinessTypes:"/payment-site/settings",
    getAchConfigFlag: '/stripe/getAch-conf',
    plaidAccessToken: '/plaid/get-access-token',
    getbanking: '/plaid/auth',
    getAchToken:'/cardconnect/tokenize-ach',
    getEstimateDashboardToken: '/user/estimate-dashboard-token',
    getFeatureFlags: "/feature-flag/customer",
  }
};

const env = {
  development: {
    debug : true,
    api: `${server}${version}`,
    dashboardApi: `${dashboardServer}/api`,
    server:server,
    title: "GoSite",
    cookies: {
      name: 'gosite',
      expiry: 7,
      domain: ""
    },
    captchaKey:'6LdCTC0UAAAAAJqltNid5LYtJyjLOydnkWB5ecxM',
    intercom:"uc6f93lc",
    cardconnectUrl:"https://fts-uat.cardconnect.com/itoke/ajax-tokenizer.html?sendcssloadedevent=true&formatinput=true&tokenizewheninactive=true&inactivityto=300&invalidinputevent=true&placeholder=Card Number&cardnumbernumericonly=true&cardinputmaxlength=19&css=.error%7Bcolor%3Ared%3B%7Dinput%7Bwidth%3A100%25%3Bheight%3A40px%3Bpadding%3A%200%2010px%3Bborder-radius%3A%204px%3Bbox-sizing%3Aborder-box%3Bcolor%3Argba%2887%2C%20108%2C%20119%2C%201%29%3Bborder%3Anone%3Bborder%3A%20solid%201px%20rgb%28224%2C%20228%2C%20232%29%3Bfont-size%3A%2013px%3Boutline%3A0%3B%7D%3A%3Aplaceholder%7Bcolor%3Argba%280%2C0%2C0%2C0.5%29%3Bfont-weight%3A400%3B%7Dbody%7Bmargin%3A0%3B%7D",
    googlePay: {
      environment: "TEST",
      merchantId: "12345678901234567890",
      merchantName: "Demo Merchant"
    },
    publishedV3SitesUrl: "https://my.gosite.run/",
    plaid_port: "8000",
    plaid_env:"sandbox",
    stripe_pk: "pk_test_ZbnU0vpCV6NGTLPOFMEm138200rBAvMr20",
    estimateDashboardUrl: 'https://estimates.gosite.run'
  },
  staging: {
    debug : false,
    api: `${server}${version}`,
    dashboardApi: `${dashboardServer}/api`,
    title: "GoSite",
    cookies: {
      name: 'gosite',
      expiry: 7,
      domain: ""
    },
    captchaKey:'6LdCTC0UAAAAAJqltNid5LYtJyjLOydnkWB5ecxM',
    intercom:"uc6f93lc",
    cardconnectUrl:"https://fts-uat.cardconnect.com/itoke/ajax-tokenizer.html?sendcssloadedevent=true&formatinput=true&tokenizewheninactive=true&inactivityto=300&invalidinputevent=true&placeholder=Card Number&cardnumbernumericonly=true&cardinputmaxlength=19&css=.error%7Bcolor%3Ared%3B%7Dinput%7Bwidth%3A100%25%3Bheight%3A40px%3Bpadding%3A%200%2010px%3Bborder-radius%3A%204px%3Bbox-sizing%3Aborder-box%3Bcolor%3Argba%2887%2C%20108%2C%20119%2C%201%29%3Bborder%3Anone%3Bborder%3A%20solid%201px%20rgb%28224%2C%20228%2C%20232%29%3Bfont-size%3A%2013px%3Boutline%3A0%3B%7D%3A%3Aplaceholder%7Bcolor%3Argba%280%2C0%2C0%2C0.5%29%3Bfont-weight%3A400%3B%7Dbody%7Bmargin%3A0%3B%7D",
    googlePay: {
      environment: "TEST",
      merchantId: "12345678901234567890",
      merchantName: "Demo Merchant"
    },
    publishedV3SitesUrl: "https://my.gosite.run/",
    plaid_port: "8000",
    plaid_env:"sandbox",
    stripe_pk: "pk_test_ZbnU0vpCV6NGTLPOFMEm138200rBAvMr20",
    estimateDashboardUrl: 'https://estimates.gosite.run'
  },
  production: {
    debug : false,
    api: `${server}${version}`,
    dashboardApi: `${dashboardServer}/api`,
    title: "GoSite",
    cookies: {
      name: 'gosite',
      expiry: 7,
      domain: ""
    },
    captchaKey:'6LdCTC0UAAAAAJqltNid5LYtJyjLOydnkWB5ecxM',
    intercom:"sxnxlfvn",
    cardconnectUrl:"https://fts.cardconnect.com:8443/itoke/ajax-tokenizer.html?sendcssloadedevent=true&formatinput=true&tokenizewheninactive=true&inactivityto=300&invalidinputevent=true&placeholder=Card Number&cardnumbernumericonly=true&cardinputmaxlength=19&css=.error%7Bcolor%3Ared%3B%7Dinput%7Bwidth%3A100%25%3Bheight%3A40px%3Bpadding%3A%200%2010px%3Bborder-radius%3A%204px%3Bbox-sizing%3Aborder-box%3Bcolor%3Argba%2887%2C%20108%2C%20119%2C%201%29%3Bborder%3Anone%3Bborder%3A%20solid%201px%20rgb%28224%2C%20228%2C%20232%29%3Bfont-size%3A%2013px%3Boutline%3A0%3B%7D%3A%3Aplaceholder%7Bcolor%3Argba%280%2C0%2C0%2C0.5%29%3Bfont-weight%3A400%3B%7Dbody%7Bmargin%3A0%3B%7D",
    googlePay: {
      environment: "PRODUCTION",
      merchantId: "BCR2DN6TT7C2TEKQ",
      merchantName: "GoSite"
    },
    publishedV3SitesUrl: "https://my.gosite.app/" ,
    plaid_port: "8000",
    plaid_env:"production",
    stripe_pk: "pk_live_TUIpbIpr2T7FRGvg4kdeKURJ00P4EqCyf2",
    estimateDashboardUrl: 'https://estimates.gosite.com'
  }
};

export default {
  ...all,
  ...env[process.env.REACT_APP_ENV || "development"]
};
